import { lazy, Suspense } from 'react';

const LazyProcessMining = lazy(
  () =>
    import(
      /* webpackChunkName: "icp-mining" */
      /* webpackPrefetch: true */
      './ProcessMining'
    ),
);

const LazyDataMining = lazy(
  () =>
    import(
      /* webpackChunkName: "icp-mining" */
      /* webpackPrefetch: true */
      './DataMining'
    ),
);

const LazyProcessMiningResult = lazy(() =>
  import(
    /* webpackChunkName: "icp-mining" */
    /* webpackPrefetch: true */
    './ProcessMining'
  ).then((module) => ({ default: module.ProcessMiningResult })),
);

const LazyDataMiningResult = lazy(() =>
  import(
    /* webpackChunkName: "icp-mining" */
    /* webpackPrefetch: true */
    './DataMining'
  ).then((module) => ({ default: module.DataMiningResult })),
);

export function ProcessMining(props) {
  return (
    <Suspense fallback={null}>
      <LazyProcessMining {...props} />
    </Suspense>
  );
}

export function DataMining(props) {
  return (
    <Suspense fallback={null}>
      <LazyDataMining {...props} />
    </Suspense>
  );
}

export function ProcessMiningResult(props) {
  return (
    <Suspense fallback={null}>
      <LazyProcessMiningResult {...props} />
    </Suspense>
  );
}

export function DataMiningResult(props) {
  return (
    <Suspense fallback={null}>
      <LazyDataMiningResult {...props} />
    </Suspense>
  );
}
